import React, { Component } from 'react';
import axios from 'axios';
import Chart from 'react-google-charts'

class TestComponent extends Component {

    state = {
        data : {},
        chartData : [],
        loadingStatus : 'loading'
    }
   

    showLoader(){
        this.setState({
            loadingStatus : 'loading'
        })
    }

    test(){
        this.setState({
            cool : "No"
        })
    }

    componentDidUpdate(prevProps){
        if(prevProps.date !== this.props.date) {
            this.showLoader();
            axios.get(`https://hanna-sprint-api.herokuapp.com/getDay/${this.props.date}`).then
            (res => this.setState({
                data : res.data
            })).then(async res => {
                let chartArr = await this.setChartData();
                this.setState({
                    chartData : chartArr,
                    loadingStatus : 'ready',
                    color : this.props.color
                })
            }).catch(err => {
                console.log(err);
            });
        }
    }




    async setChartData(){

        let chartData = [["Time", "Distance"]];
        this.state.data.entries.forEach(element => {
            let tempArr = [element.timeStamp, element.distance / 100]
            chartData.push(tempArr);
        });
        return chartData;
    }
   

    
    render(){
        return this.state.loadingStatus === 'ready' ? (
            
        <div>
            <div className="dayChart">
                <h1 className="dateTitle">{this.state.data.date}, meters</h1>
                <Chart
                loader={<h1>Laddar din morsa</h1>}
                className="dayChartSub"
                width={'100%'}
                chartType="Line"
                data={this.state.chartData}
                options={{
                    animations: {
                        startup: true
                    },
                    legend: { position: "none" },
                    chartArea: {
                        width: '100%'
                    },
                    title: this.state.data.date,
                    colors: this.state.color
                }}
                rootProps={{'data-testid': '1'}}
            />
            </div>
        </div>
        ) : (
            <div>Fetching the stats from the API</div>
        )
    }
}

export default TestComponent;